/**
 * PB-FND-73 — Topic Multi field plugin (registry adapter).
 * Extracted from pb-field-runtime; wired via createTopicMultiAdapter(deps).
 * Shared Continue gate (validateTopicMultiGate) stays in field-runtime — injected via deps.
 */

function initTopicMultiStepFromRegistry(stepEl, ctx) {
  const pb = ctx?.pb || (typeof window !== 'undefined' ? window.productBuilder : null);
  const grid = stepEl?.querySelector('[data-topic-list]');
  if (!grid || !pb) return;
  const rawList = grid.dataset.topicList || '';
  const parsed =
    typeof pb.parseTopicSettings === 'function'
      ? pb.parseTopicSettings(rawList)
      : { topics: [], rules: {} };
  const topics = parsed.topics || [];
  const currentRows = grid.querySelectorAll('.pb-topic-row').length;
  const willRender = currentRows !== topics.length || grid.dataset.topicRendered !== 'true';
  if (willRender && typeof pb.renderTopicButtons === 'function') {
    pb.renderTopicButtons(grid, topics);
  }
  if (typeof pb.applyTopicRules === 'function') {
    pb.applyTopicRules(grid, parsed.rules || {});
  }
}

/**
 * @param {object} deps — shared field-runtime helpers (avoids circular mega-body)
 */
export function createTopicMultiAdapter(deps) {
  const {
    resolveEsc,
    settingsToString,
    renderControlShell,
    renderImageColumn,
    validateTopicMultiGate,
  } = deps;

  return {
    id: 'topic-multi',
    matches(field) {
      return String((field && field.type) || '').includes('TopicMulti');
    },
    renderStep(ctx) {
      const field = ctx.field;
      const esc = resolveEsc(ctx);
      const settingsStr = settingsToString(field.settings);
      const innerHtml =
        '<div class="pb-topic-list pb-topic-multi btn-grid" data-topic-list="' +
        esc(settingsStr) +
        '"></div>';
      const visRaw = String(field.visual || '').trim();
      return {
        controlHtml: renderControlShell(field, innerHtml, ctx, { useQuestionHighlight: !visRaw }),
        imageHtml: renderImageColumn(field, ctx),
        stepAttrs: ' data-topic-multi="true" data-topic-label="' + esc(field.label) + '"',
        extraClasses: !visRaw ? 'pb-step-hide-question' : '',
      };
    },
    initStep(stepEl, ctx) {
      initTopicMultiStepFromRegistry(stepEl, ctx);
      if (typeof window !== 'undefined' && window.productBuilder?._pbBuildingTopicSteps) return;
      if (typeof window !== 'undefined' && window.productBuilder?.buildTopicSteps) {
        const selected =
          ctx?.topicSelections?.[stepEl?.dataset?.topicLabel || ''] ||
          window.builderState?.main?.topicSelections?.[stepEl?.dataset?.topicLabel || ''];
        if (Array.isArray(selected) && selected.length > 0) {
          window.productBuilder.buildTopicSteps(stepEl);
        }
      }
    },
    validateStep(stepEl) {
      return validateTopicMultiGate(stepEl);
    },
    hydrateStep(stepEl, ctx) {
      this.initStep(stepEl, ctx);
    },
    flushStep(stepEl, ctx) {
      if (typeof window !== 'undefined' && window.productBuilder?.flushTopicMultiStep) {
        window.productBuilder.flushTopicMultiStep(stepEl, ctx);
      }
    },
  };
}
